function activeMenu() {
  // Get all menu items
  const menuItems = document.querySelectorAll('.m-item');
  
  // Options for the IntersectionObserver
  const options = {
    root: null, // Use the viewport as the observation area
    rootMargin: '-20% 0px', // Add a margin to trigger a bit earlier/later
    threshold: 0.2 // Percentage of element that must be visible to trigger the callback
  };

  // Callback function that executes when a section enters/exits the screen
  const callback = function(entries) {
    entries.forEach(entry => {
      // Get the ID of the section without the # prefix
      const id = entry.target.id;
      
      // Find the corresponding menu item
      const correspondingMenuItem = document.querySelector(`.m-item[href="#${id}"]`);
      
      if (entry.isIntersecting) {
        // Add active class to the menu item when its section is visible
        if (correspondingMenuItem) {
          // Remove active class from all menu items first
          menuItems.forEach(item => {
            item.classList.remove('active');
          });
          
          // Add active class to the current menu item
          correspondingMenuItem.classList.add('active');
        }
      }
    });
  };

  // Create an IntersectionObserver instance with the callback and options
  const observer = new IntersectionObserver(callback, options);
  
  // Get all sections that correspond to menu items
  menuItems.forEach(item => {
    // Extract the ID from the href attribute (remove the # character)
    const sectionId = item.getAttribute('href').replace('#', '');
    
    // Find the corresponding section
    const section = document.getElementById(sectionId);
    
    // If the section exists, observe it
    if (section) {
      observer.observe(section);
    }
  });
}

export default activeMenu;
